import { ELOAEventEnum } from "@ntprsrf-frontend/service/src/requests/internet/eloa.request";
import { firstValueFrom, Observable } from "rxjs";
import { RouteLocationNormalized } from "vue-router";

type AuditFunction = (params) => Observable<any>;

export const performAudit = async (route: RouteLocationNormalized) => {
  const auditFn = route.meta?.auditFn as AuditFunction;
  if (!auditFn) {
    return;
  }
  await firstValueFrom(auditFn({
    event: ELOAEventEnum.PAGE_EXIT,
    pageIndex: route.meta?.pageIndex as number,
    pageName: route.meta?.label as string,
  }));
};